<div class="ktbl-spacer-top-bottom"></div>



<div class="ktbl-container">
  <div class="ktbl-row-mehrspaltig-2-elemente">
    <mat-form-field class="ktbl-input-box" appearance="fill">
      <mat-label>Projektname</mat-label>

      <input matInput required [errorStateMatcher]="matcher" [formControl]="bezeichnungFormControl" />
      <mat-error *ngIf="bezeichnungFormControl.invalid">
        Es wird ein Projektname für die Berechnung benötigt
      </mat-error>
    </mat-form-field>

    <mat-form-field class="ktbl-input-box" appearance="fill">
      <mat-label>Projektbeschreibung</mat-label>
      <input matInput [errorStateMatcher]="matcher" [formControl]="beschreibungFormControl" />
    </mat-form-field>
  </div>

  <div class="ktbl-spacer-top-bottom"></div>

  <mat-tab-group [(selectedIndex)]="selectedTabIndex" mat-align-tabs="start" dynamicHeight="true"
    animationDuration="0ms">

    <mat-tab label="Betrieb" class="tab-reiter">
      <app-betrieb></app-betrieb>
    </mat-tab>

    <mat-tab label="Winddaten und Gebietskategorie" class="tab-reiter">
      <app-winddaten-gebietskategorie></app-winddaten-gebietskategorie>
    </mat-tab>
  </mat-tab-group>

  <div class="ktbl-spacer-top-bottom"></div>

  <div class="ktbl-row-mehrspaltig-2-elemente">
    <div class="ktbl-button-container-left">
      <button (click)="onClickEntfernenInputs()" class="ktbl-button-sekundaer ktbl-button-width-m ktbl-button-width-m-c"
        type="button">

        <i class="fas fa-trash ktbl-icon-vertical-align"></i>
        {{ selectedTabIndex === 0 ? 'Entfernen der Quelldaten' : 'Entfernen der Winddaten' }}

      </button>


    </div>

    <div class="ktbl-button-container-right">
      <button (click)="onClickZuErgebnisse()" class="ktbl-button-primaer ktbl-button-width-m" type="button"
        [disabled]="isDisabled">
        Zum Ergebnis
        <i class="fas fa-arrow-right ktbl-icon-vertical-align"></i>
      </button>
    </div>
  </div>



  <div class="ktbl-floating-container-ohne-rand-wrapper">
    <div class="ktbl-floating-info" *ngIf="selectedTabIndex">
      Gesamt Windhäufigkeit in ‰: {{ windhaeufigkeitSumme }}
    </div>

    <div class="ktbl-floating-content">
      <button (click)="onClickZuErgebnisse()" mat-raised-button class="ktbl-button-primaer ktbl-button-icon-l"
        type="button" matTooltip="Zu Ergebnisse" [matTooltipPosition]="tooltipPosition.value"
        matTooltipClass="tooltip-format" [disabled]="isDisabled">
        <i class="fas fa-arrow-right ktbl-icon-vertical-align"></i>
      </button>

      <button (click)="onClickUp()" mat-raised-button class="ktbl-button-primaer ktbl-button-icon-l" type="button">
        <i class="fas fa-chevron-up ktbl-icon-vertical-align"></i>
      </button>

      <button (click)="onClickDown()" mat-raised-button class="ktbl-button-primaer ktbl-button-icon-l" type="button">
        <i class="fas fa-chevron-down ktbl-icon-vertical-align"></i>
      </button>
    </div>
  </div>
</div>
<div class="ktbl-spacer-top-bottom"></div>